import {Customer} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {NavLink} from "react-router-dom";
import {CustomerStatusBadge} from "../profile/CustomerStatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";

export const useTableColumns = () => {
    let columns: DataTableColumn<Customer>[] = [];


    const additional = [
        {
            accessor: 'name',
            title: I18n.get('Customer'),
            width: '1fr',
            render: (item: Customer) => <NavLink to={`/customers/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '120px',
            render: (item: Customer) => <CustomerStatusBadge status={item.status}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Customer) => formatTimestamp(item.created as string),
        },

    ];

    columns = columns.concat(additional);


    return {
        columns,
    }
}